import { flow } from 'mobx';

export const upgradeBooking = flow(function* (config) {
  const requestBody = {
    agencyNumber: config.agencyNumber,
    serviceCode: 'S',
    SpecialServiceCode: config.SpecialServiceCode || 'FLEX',
    SpecialServiceRequirement: config.SpecialServiceRequirement || 'S',
  };

  try {
    const response = yield fetch(`/api/upgrades/book`, {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    });

    if (response.status !== 201) {
      throw new Error('Error while booking upgrade');
    }

    const data = yield response.json();

    if (data?.success === false) {
      throw new Error('Error while booking upgrade');
    }

    return { success: true, message: data?.message };
  } catch (error) {
    return { success: false, error };
  }
});

export const getVacancy = flow(function* (config) {
  const requestBody = {
    agencyNumber: config.agencyNumber,
    billNumber: config.billNumber,
    serviceCode: 'S',
    SpecialServiceCode: config.SpecialServiceCode || 'FLEX',
    SpecialServiceRequirement: config.SpecialServiceRequirement || 'S',
  };

  try {
    const response = yield fetch(`/api/upgrades/vacancy`, {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    });

    if (response.status !== 201) {
      throw new Error('Error while booking upgrade');
    }

    const data = yield response.json();

    return data;
  } catch (error) {
    console.error(error);
    return { success: false };
  }
});
